import { TranslateService } from "@ngstack/translate";
import { BIDService } from "src/app/services/common/bid.service";
import { Component, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import {
  MatTableDataSource,
  MatSelectChange,
  MatDialog
} from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICourseType } from "src/app/interfaces/course-type";
import { IDiscountgGroup } from "src/app/interfaces/discount-group";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ConfirmRegistrationEntryComponent } from "../confirm-registration-entry/confirm-registration-entry.component";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { HidService } from "src/app/services/common/hid.service";
import { environment } from "src/environments/environment";

import { ProvinceService } from "src/app/services/http/business/province/provinces.service";
import { IProvince } from "src/app/interfaces/province";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-registration-course',
  templateUrl: './registration-course.component.html',
  styleUrls: ['./registration-course.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RegistrationCourseComponent implements OnInit, OnDestroy {
  data: any;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  isOwner: boolean;
  errors = new Array();
  branchesList: IBranch[];
  selectedIndex: number;
  allBranches: IBranch[];
  submitReg: boolean = true;
  showTab: boolean = false;
  showTable: boolean = false;
  courseTypeList: ICourseType;
  showSubmit: boolean = false;
  termInfoTable: boolean = false;
  showCourseType: boolean = false;
  showBranches: boolean = false;
  //emptyTermInfoTable: boolean = false;
  discountList: IDiscountgGroup[] = [];
  memorandumDiscountList = [];
  provinceList: IProvince;
  levels = [];
  emptyPersonInfoTable: boolean = false;
  showRegistrationTable: boolean = false;
  showlevelsCanBeRegistered = false;
  queryParams: any;
  level: any;
  hasRegistration: boolean;
  model: any = {
    nationalCode: String,
    courseId: Number,
    levelId: Number,
    courseTypeId: Number,
    termInfoId: Number,
    branchEncryptId: String,
    ProvinceId: Number,
    discountGroupId: null,
    userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
    getUnderstandingDiscountId: null,
    courseTypeName: String
  };
  ProvinceId: number;
  BranchEncryptId: string;

  colors: string[];
  baaseUrl = environment.BaaseUrl;
  showAllCourseForQuickRegister = false;

  personDiscountGroup: string;
  UnderstandingDiscount: string;
  ProvinceName: any;
  BranchName: any;
  allBranchChecked: boolean = false;
  hasCourseForQuickRegister = false;
  showQuickRegisterSwitch = false;
  CourseForQuickRegisterDataSource: any;

  constructor(
    private dialog: MatDialog,
    private hidService: HidService,
    private bidService: BIDService,
    public translate: TranslateService,
    private provinceService: ProvinceService,
    private branchService: BranchService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private studentService: StudentService,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.accountService.getUserInfo().subscribe(res => {
      this.hasRegistration = res.HasRegistration
    }, () => { }, () => {
      this.queryParams = {
        holdingEncryptId: this.hidService.getHID()
      };
      if (this.hasRegistration) {
        this.getNextLevelForQuickRegister();
      }
      else {
        this.loadProvience();
      }
    });

  }

  displayedColumns: string[] = [
    "radio",
    "educationPackage",
    "level"
  ];

  dataSource = new MatTableDataSource();

  onItemChange(item: any) {

    this.model.levelId = item.LevelId;
    this.level = this.data.find(level => level.LevelId == item.LevelId);
    this.nextTab();
  }
  onItemChange2(item: any) {

    this.model.levelId = item.LevelId;
    this.level = this.data.find(level => level.LevelId == item.LevelId);
    this.showCourseType = true;
    this.loadCourseType(this.model.branchEncryptId);
  }
  getLevels() {

    // this.errors = new Array();
    this.studentService.getLevelsSTU(this.queryParams)
      .subscribe(
        res => {

          if (res.length == 0) {
            this.emptyPersonInfoTable = true;
            this.showlevelsCanBeRegistered = false;
          }
          else {
            this.data = res;
            this.showTable = true;
            this.dataSource = res;
            this.levels = res;
            this.emptyPersonInfoTable = false;
            this.showlevelsCanBeRegistered = true;
          }
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error)
        }
      );
  }

  getLevels2(branch:any) {
    this.showCourseType = false;
    this.model.branchEncryptId = branch
    this.courseTypeList = null;
    // this.errors = new Array();
    this.studentService.getLevelsSTU(this.queryParams)
      .subscribe(
        res => {

          if (res.length == 0) {
            this.emptyPersonInfoTable = true;
            this.showlevelsCanBeRegistered = false;
          }
          else {
            this.data = res;
            this.showTable = true;
            this.dataSource = res;
            this.levels = res;
            this.emptyPersonInfoTable = false;
            this.showlevelsCanBeRegistered = true;
          }
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error)
        }
      );
  }

  getNextLevelForQuickRegister() {
    debugger
    this.studentService.getNextLevelForQuickRegister(this.queryParams)
      .subscribe(
        res => {
          if (res.length != 0) {
            debugger
            this.hasCourseForQuickRegister = true;
            this.showQuickRegisterSwitch = true;
            this.CourseForQuickRegisterDataSource = res.filter(function (item) {
              return item.FilterCourseTypeId == item.CourseTypeId;
            });
            this.registrationas = res;
          }
        }, () => { }, () => {
          this.getLevels();
        }
      );
  }



  AllCourseForQuickRegister() {
    this.showAllCourseForQuickRegister = !this.showAllCourseForQuickRegister;
    if (this.showAllCourseForQuickRegister)
      this.CourseForQuickRegisterDataSource = this.registrationas;
    else
      this.CourseForQuickRegisterDataSource = this.registrationas.filter(function (item) {
        return item.FilterCourseTypeId == item.CourseTypeId;
      });


  }

  nextTab() {

    this.allBranchChecked = false;
    this.showTab = true;
    this.selectedIndex = 1;
    this.getLatestRegistrationArea();
    this.loadProvience();
    this.submitReg = true;
    //this.getBranchListByNationalCodeAndPackage();
  }

  //   --2 Teen	نوجوانان      حضوری      Onsite
  // --8 Translation	ترجمه      حضوری      Onsite     
  // --12 supermind	کودکان      حضوری      Onsite  
  // --15 NewHybrid	مکالمه      حضوری      Onsite
  // --17 Cybertalk	مکالمه      مجازی     Online 
  // --3132 Tendance	حضوری      Onsite  
  // --3136 NewIELTS	 Onsite     حضوری    IELTS
  // --3137 IELTSONLINE	 Online    مجازی      IELTS
  // --3139 Translation Online	ترجمه      مجازی     Online 
  // --3142 TTC	جذب مدرس      مجازی     Online 
  // --3147 Teen Online	نوجوانان      مجازی      Online
  // --3133 Skype French	فرانسه      مجازی      Online  

  getPackageType(level: any) {
    // let hz = [2, 8, 12, 15, 3132, 3136];
    // let on = [17, 3137, 3139, 3142, 3147, 3133];
    switch (level.PackageId) {
      case 2:
        return 'نوجوانان &nbsp;&nbsp;&nbsp; حضوری &nbsp;&nbsp;&nbsp; Onsite';
      case 8:
        return 'ترجمه &nbsp;&nbsp;&nbsp; حضوری &nbsp;&nbsp;&nbsp; Onsite';
      case 12:
        return 'کودکان &nbsp;&nbsp;&nbsp; حضوری &nbsp;&nbsp;&nbsp; Onsite';
      case 15:
        return 'مکالمه &nbsp;&nbsp;&nbsp; حضوری &nbsp;&nbsp;&nbsp; Onsite';
      case 17:
        return 'مکالمه &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; Online';
      case 3132:
        return 'حضوری &nbsp;&nbsp;&nbsp; Onsite';
      case 3136:
        return 'Onsite &nbsp;&nbsp;&nbsp; حضوری &nbsp;&nbsp;&nbsp; IELTS';
      case 3137:
        return 'Online &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; IELTS';
      case 3139:
        return 'ترجمه &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; Online';
      case 3142:
        return 'جذب مدرس &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; Online';
      case 3147:
        return 'نوجوانان &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; Online';
      case 3133:
        return 'فرانسه &nbsp;&nbsp;&nbsp; مجازی &nbsp;&nbsp;&nbsp; Online';
      default:
        return '';
    }

    // if (hz.includes(level.PackageId))
    //   return '';
    // //return 'حضوری   <span class="pdes">Onsite</span>';
    // else if (on.includes(level.PackageId))
    //   return '';
    // //return 'مجازی   <span class="pdes">Online</span>';
    // else
    //   return '';


  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }

  getLatestRegistrationArea() {
    this.studentService.getLatestRegistrationArea(this.model.userInfo.NationalCode).subscribe(res => {
      if (res.ProvinceId && res.BranchEncryptId) {
        this.ProvinceId = res.ProvinceId;
        this.ProvinceName = res.ProvinceName;
        this.BranchEncryptId = res.BranchEncryptId;
        this.BranchName = res.BranchName;
        this.loadCourseType(res.BranchEncryptId);
      }
      else {
        this.allBranchChecked = true;
      }
    })
  }

  showAllBranch() {
    this.allBranchChecked = !this.allBranchChecked;
    this.submitReg = true;
  }

  showAdvance() {
    this.hasCourseForQuickRegister = !this.hasCourseForQuickRegister;
    this.submitReg = true;

    this.studentService.getNextLevelForQuickRegister(this.queryParams)
      .subscribe(
        res => {
          if (res.length != 0) {
            this.showQuickRegisterSwitch = true;
            this.CourseForQuickRegisterDataSource = res.filter(function (item) {
              return item.FilterCourseTypeId == item.CourseTypeId;
            });
            this.registrationas = res;
          }
        }, () => { }, () => {
          this.getLevels();
        }
      );

    this.showAllCourseForQuickRegister = false;
  }

  onLinkClick(e) {

    this.selectedIndex = e.index;
  }
  // دریافت لیست شعبه بر اساس سطوح و جنیست برای کاربر جاری
  getBranchListByNationalCodeAndPackage(ProvinceId: Number) {

    let command = {
      HoldingEncryptId: this.queryParams.holdingEncryptId,
      PackageId: this.level.PackageId,
      ProvinceId: ProvinceId
    };

    this.studentService.getBranchListByNationalCodeAndPackage(command).subscribe(
      res => {
        this.branchesList = res;
        this.showBranches = true;
        if (res.length <= 0) {
          this.snackBar.OpenSnackBar(
            "دوره فعالی در استان انتخاب شده وجود ندارد",
            "ok",
            3000,
            SoundEnum.beep
          );
        }
      },
      () => {
        this.errorService.transactionError();
      }
    );
    this.submitReg = true;
  }

  getpresenceBranchByProvinceId(ProvinceId: any) {

    // let command = {
    //   HoldingEncryptId: this.queryParams.holdingEncryptId,
    //   PackageId: this.level.PackageId,
    //   ProvinceId: ProvinceId
    // };

    this.branchService.getpresenceBranchByProvinceId(ProvinceId).subscribe(
      res => {
        this.branchesList = res;
        this.showBranches = true;
        // if (res.length <= 0) {
        //   this.snackBar.OpenSnackBar(
        //     "دوره فعالی در استان انتخاب شده وجود ندارد",
        //     "ok",
        //     3000,
        //     SoundEnum.beep
        //   );
        // }
      },
      () => {
        this.errorService.transactionError();
      }
    );
    //this.submitReg = true;
  }

  loadCourseType(branchId: string) {
    this.termInfoDataSource = new MatTableDataSource();
    this.registrationDataSource = new MatTableDataSource();
    this.model.branchEncryptId = branchId;
    if (this.isOwner)
      this.bidService.setBID(this.model.branchEncryptId);
    this.queryParams["branchEncryptId"] = this.model.branchEncryptId;
    this.queryParams["LevelInfoId"] = this.model.levelId;
    this.studentService.coursesTypeByCurentBranchAndLevel(this.queryParams).subscribe(res => {

      this.showCourseType = true;
      this.courseTypeList = res;
      if (!res || res.length <= 0) {
        this.snackBar.OpenSnackBar(
          "دوره فعالی در این شعبه وجود ندارد",
          "ok",
          3000,
          SoundEnum.beep
        );
      }
    });
    this.submitReg = true;
  }

  ///term info data source
  termDisplayedColumns: string[] = [
    "radio",
    "termNumber",
    "termName",
    "termStartTime",
    "termEndTime"
  ];
  termInfoDataSource = new MatTableDataSource();

  //دریافت لیست توضیحات ترم بر اساس شناسه نوع ترم و زمانی که در آن هستیم دای دانشجو
  loadTermInfo(e: MatSelectChange) {
    this.registrationDataSource = new MatTableDataSource();
    // if (this.emptyTermInfoTable) {
    //   this.emptyTermInfoTable = false;
    // }
    this.model.courseTypeName = e.value.Title;
    this.model.courseTypeId = e.value.Id;
    let data = {
      CourseTypeId: e.value.Id,
      xPage: 1,
      xPageSize: 5,
      xOrderBy: "",
      xOrderDesc: true,
      BranchEncryptId: this.model.branchEncryptId
    };
    this.studentService.getListByJustCourseTypeIdSTU(data).subscribe(
      res => {

        if (res.Total == 0) {
          this.snackBar.OpenSnackBar(
            "ترم فعالی برای این الگو یافت نشد ! لطفا در زمان ثبت نام مراجعه فرمایید",
            "ok",
            6000,
            SoundEnum.beep
          );
          //this.emptyTermInfoTable = true;
          this.termInfoTable = false;
        } else {
          this.termInfoTable = true;
          this.termInfoDataSource = res.DataList;
        }
      },
      () => {
        this.errorService.transactionError();
      }
    );
    this.submitReg = true;
  }

  paginatorEvent(event) {
    let data = {
      CourseTypeId: this.model.courseTypeId,
      xPage: event.pageIndex + 1,
      xPageSize: event.pageSize,
      xOrderBy: "",
      xOrderDesc: true,
      BranchEncryptId: this.model.branchEncryptId
    };
    this.studentService.getListByJustCourseTypeIdSTU(data).subscribe(res => {
      this.dataSource = res.DataList;
    });
  }

  //registration Table Datasource
  registrationDisplayedColumns: string[] = [
    "radio",
    "branch",
    "patternName",
    "level",
    "term",
    "teacherName",
    "startDate",
    "endDate",
    "startTime",
    "endTime",
    "price",
    "discount",
    // "capacity",
    // "isRegisterd",
    "gender"
  ];
  registrationDataSource = new MatTableDataSource();
  registrationas = [];

  OntermInfo(e: any) {


    this.model.termInfoId = e.target.value;
    var data = {
      TermInfoId: this.model.termInfoId,
      CourseTypeId: this.model.courseTypeId,
      BranchEncryptId: this.model.branchEncryptId,
      LevelInfoId: this.model.levelId,
      Id: 0,
      xPage: 0,
      xPageSize: 0,
      xOrderBy: "",
      xOrderDesc: true
    };
    this.studentService.ListCourseForRegisterSTU(data).subscribe(
      res => {

        this.showRegistrationTable = true;
        this.registrationas = res;
        this.registrationDataSource = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCourseIdForQuickRegister(course: any) {
    debugger
    this.model.courseId = course.Id;
    this.model.termInfoId = course.TermInfoId;
    this.model.branchEncryptId = course.BranchEncryptId,
      this.model.levelId = course.LevelInfoId
    this.model.courseTypeId = course.CourseTypeId,
      this.model.courseTypeName = course.CourseTypeName,
      this.getDiscount();
    this.getUnderstandingDiscountCombo();
    this.submitReg = false;
  }

  getCourseId(event: any) {
    this.model.courseId = event.target.value;
    this.getDiscount();
    this.getUnderstandingDiscountCombo();
    this.submitReg = false;
  }

  getDiscount() {
    debugger
    this.studentService.discountPersonList(this.model).subscribe(res => {
      if (res && res.length > 0) {
        this.discountList = res
        var dis = res.reduce(function (prev, current) {
          return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
        })

        // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
        this.model.discountGroupId = dis.Id;
        this.personDiscountGroup = dis.Title;
      }
      else {
        this.model.discountGroupId = null;
      }
      //   this.discountList = res;
      //   if (this.discountList.length == 0)
      // });
    })
  }

  getUnderstandingDiscountCombo() {
    this.studentService.getUnderstandingDiscountCombo(this.model)
      .subscribe(res => {
        this.memorandumDiscountList = res;
        if (res && res.length > 0) {

          var dis = res.reduce(function (prev, current) {
            return (prev.DiscountPercent > current.DiscountPercent) ? prev : current
          })

          // var dis = Math.max.apply(Math, res.map(function (o) { return o.DiscountPercent; }))
          this.model.getUnderstandingDiscountId = dis.Id;
          this.UnderstandingDiscount = dis.Title;
        }
        else {
          this.model.getUnderstandingDiscountId = null;
        }

        // this.memorandumDiscountList = res;
        // if (this.memorandumDiscountList.length == 0)
        //   this.model.getUnderstandingDiscountId = null;

      });
  }

  getStyle(e: any): string {
    //var curCapacity = e.CapacityFreeOnline;// (e.MaxCapacity < e.RoomCapacity) ? e.MaxCapacity : e.RoomCapacity;
    if (e.IsValid && this.checkCapacity(e)) {
      var curCapacity = (e.MaxCapacity < e.RoomCapacity) ? e.MaxCapacity : e.RoomCapacity;
      if (e.RegisterCount <= (curCapacity * 30 / 100))
        return '#B3CEFF';

      else if (e.RegisterCount > (curCapacity * 30 / 100) && e.RegisterCount <= (curCapacity * 60 / 100))
        return '#5AFA53';

      else if (e.RegisterCount > (curCapacity * 60 / 100) && e.RegisterCount < curCapacity)
        return '#FFD22D';

      else //(e.RegisterCount == e.Capacity)
        return '#FF8080';
    }
    else {
      return '#FF8080';
    }
  }
  checkCapacity(e: any): boolean {
    var curCapacity = (e.MaxCapacity < e.RoomCapacity) ? e.MaxCapacity : e.RoomCapacity;
    if (e.RegisterCount >= curCapacity || e.RegisterCount >= (e.CapacityFreeOnline + e.CapacityFree) || e.OnlineRegisterCount >= e.CapacityFreeOnline)
      return false;
    else
      return true;
  }
  setDiscountGroupId(event) {

    this.model.discountGroupId = event.value;
  }
  register() {
    var _this = this;
    if (this.model) {
      var registerData = {
        Id: 0,
        NationalCode: this.model.userInfo.NationalCode,
        CourseId: this.model.courseId,
        LevelInfoId: this.model.levelId,
        registrationData: this.registrationas.find(x => x.Id == this.model.courseId),
        CourseTypeId: this.model.courseTypeId,
        TermInfoId: this.model.termInfoId,
        BranchEncryptId: this.model.branchEncryptId,
        Fullname: this.model.userInfo.FullName,
        DiscountGroupId: this.model.discountGroupId,
        discountGroup: this.model.discountGroupId ? this.discountList.filter(function (e) { return e.Id == _this.model.discountGroupId })[0] : null,
        GetUnderstandingDiscountId: this.model.getUnderstandingDiscountId,
        discountUnderstanding: this.model.getUnderstandingDiscountId ? this.memorandumDiscountList.filter(function (e) { return e.Id == _this.model.getUnderstandingDiscountId })[0] : null,
        courseTypeName: this.model.courseTypeName
      };
      this.dialog.open(ConfirmRegistrationEntryComponent, {
        data: registerData
      });
    }
  }

  ngOnDestroy(): void {
    if (this.isOwner)
      this.bidService.setBID("");
  }


}
